import axios from "axios";
import {setCurrentItemAddress} from "../action/page";

export const getAddressMap = coord => (dispatch) => {
    return new Promise((resolve, reject) => {
        axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${coord}&key=AIzaSyCupV2uK4EQSM_yWbe9BJoLF75zKZyhRcw`)
            .then((res) => {
                if(res.status === 200 && res.data.results.length) {
                    dispatch(setCurrentItemAddress(res.data.results[0].formatted_address))
                    resolve();
                }
            }).catch(err => {
                reject(err);
            });
    })
}